import { OrderCommodity } from 'types/orderCommodity.types'
import {
    ARRAY_EXTRA_FIELDS,
    DEFAULT_FREIGHT_TYPE,
    DEFAULT_LENGTH,
    DEFAULT_WIDTH,
} from './confirmShipmentDetailsWidget.constants'
import type {
    ArrayExtraFieldId,
    SimpleExtraFieldId,
} from './confirmShipmentDetailsWidget.types'
import { v4 as uuidv4 } from 'uuid'
import { ConfirmShipmentDetailsWidgetData } from 'types/widget.types'

// A utility to give each array field a default unique ID on load.
export const getDefaultStableArrayFieldIds = (
    widgetData: ConfirmShipmentDetailsWidgetData
): Record<ArrayExtraFieldId, string[]> => {
    return ARRAY_EXTRA_FIELDS.reduce((acc, arrayFieldId) => {
        acc[arrayFieldId] = (widgetData[arrayFieldId] ?? []).map(() => uuidv4())
        return acc
    }, {} as Record<ArrayExtraFieldId, string[]>)
}

// Derive simple extra fields to show by default based on the widget data.
export const getDefaultVisibleSimpleFields = (
    widgetData: ConfirmShipmentDetailsWidgetData
): Record<SimpleExtraFieldId, boolean> => {
    return {
        specialInstructions: !!widgetData.specialInstructions,
        numberOfShipments: !!widgetData.numberOfShipments,
        referenceId: !!widgetData.referenceId,
        accessorials:
            !!widgetData.accessorials && widgetData.accessorials.length > 0,
        isRushedOrder: !!widgetData.isRushedOrder,
        isApprovalRequired: !!widgetData.isApprovalRequired,
    }
}

export const getDefaultCommodity = (
    widgetData: ConfirmShipmentDetailsWidgetData
): Partial<OrderCommodity> => {
    return {
        freightType:
            widgetData.defaultCommodityFreightType || DEFAULT_FREIGHT_TYPE,
        width: widgetData.defaultCommodityWidth || DEFAULT_WIDTH,
        length: widgetData.defaultCommodityLength || DEFAULT_LENGTH,
    }
}
